import store from "../../../services/store";
import { userPermissionApi } from "../../authentication/services/userPermissionApi";
import { IUserPermission, OtherRolePermission, ROLE } from "../../authentication/types";

const DEFAULT_PROJECT_LIMIT = 1;
export const getUserProjectLimit = (email: string, role: ROLE, permissions?: IUserPermission[]): number | null => {
    // only admin can create project without projectLimit
    if (role === "admin") return null;

    const response = userPermissionApi.endpoints.getUserPermissions.select()(store.getState())?.data;

    if (!response || response.length === 0) return DEFAULT_PROJECT_LIMIT;

    const configToUse = permissions || response;
    const userConfig = configToUse.find((user) => user.email === email);
    if (userConfig?.role === "admin") {
        return null;
    }
    if (userConfig?.role === "user") {
        return (userConfig as OtherRolePermission)?.projectLimits || DEFAULT_PROJECT_LIMIT;
    }
    // other role, eg, enterprise 登入一律都是 enterprise_user
    // 目前沒有針對 enterprise 處理 專案數量 限制, 先使用 DEFAULT_PROJECT_LIMIT(1)
    return (userConfig as OtherRolePermission)?.projectLimits || DEFAULT_PROJECT_LIMIT;
};

export const checkProjectLimitNotExceed = (currentProjectNum: number, projectLimit: number | null) => {
    if (!projectLimit) return true;
    if (currentProjectNum >= projectLimit) return false;
    return true;
};
